import { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../../components/Modal";
import { getHeaderTheme } from "../../config/headerTheme";

const theme = getHeaderTheme();

const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

const WebinarModal = ({ isOpen, webinar, usuario, onClose, onConfirm }) => {
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [errors, setErrors] = useState({ nombre: "", correo: "" });

  useEffect(() => {
    if (isOpen && usuario) {
      setNombre(usuario.nombre || "");
      setCorreo(usuario.correo || "");
      setErrors({ nombre: "", correo: "" });
    }
  }, [isOpen, usuario]);

  const handleAccept = () => {
    const newErrors = { nombre: "", correo: "" };

    if (!nombre.trim()) {
      newErrors.nombre = "El nombre es obligatorio.";
    }

    if (!correo.trim()) {
      newErrors.correo = "El correo es obligatorio.";
    } else if (!validateEmail(correo)) {
      newErrors.correo = "El correo no es válido.";
    }

    setErrors(newErrors);

    if (!newErrors.nombre && !newErrors.correo) {
      onConfirm({ nombre: nombre.trim(), correo: correo.trim() });
    }
  };

  const handleCancel = () => {
    setErrors({ nombre: "", correo: "" });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      label={webinar ? `Inscribirme en ${webinar.titulo}` : "Inscribirme"}
      acceptButtonText="Confirmar participación"
      cancelButtonText="Cancelar"
      onAccept={handleAccept}
      onCancel={handleCancel}
      width="480px"
    >
      <Content>
        <Subtitle>Confirma tus datos para recibir el acceso al webinar.</Subtitle>
        <Form>
          <Field>
            <Label>Nombre</Label>
            <Input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Tu nombre completo"
            />
            {errors.nombre && <Error>{errors.nombre}</Error>}
          </Field>
          <Field>
            <Label>Correo electrónico</Label>
            <Input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              placeholder="tu@email.com"
            />
            {errors.correo && <Error>{errors.correo}</Error>}
          </Field>
        </Form>
      </Content>
    </Modal>
  );
};

const Content = styled.div`
  padding: 20px 8px;
`;

const Subtitle = styled.p`
  margin: 0 0 20px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
`;

const Form = styled.div`
  display: grid;
  gap: 16px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 15px;
  color: #111827;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${theme.accent};
    box-shadow: 0 0 0 3px ${theme.primaryTransparent};
  }
`;

const Error = styled.span`
  color: #ef4444;
  font-size: 12px;
`;

export default WebinarModal;
